import { render, staticRenderFns } from "./cxupload.vue?vue&type=template&id=ffe8b202&scoped=true&"
import script from "./cxupload.vue?vue&type=script&lang=js&"
export * from "./cxupload.vue?vue&type=script&lang=js&"
import style0 from "./cxupload.vue?vue&type=style&index=0&id=ffe8b202&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe8b202",
  null
  
)

export default component.exports